import React from "react";
import ReactDOM from "react-dom";
import { createGenerateClassName } from "@mui/styles";

import EntryWrapper from "./entry-wrapper";
import GlobalSearch from "./../components/global-search";

const generateClassName = createGenerateClassName({
  productionPrefix: "gls",
});

const EntryGlobalSearch = document.getElementById("sa_content_filtering_entry-global-search");
ReactDOM.render(
  <EntryWrapper generateClassName={generateClassName}>
    <GlobalSearch />
  </EntryWrapper>,
  EntryGlobalSearch
);

export default EntryGlobalSearch;
